const Config = {
  dev: {
    // hostUrl:"https://ceshi2.zysuan.com",
    // hostUrl:"https://wxapi.zysuan.com",
    host: 'http://localhost:1220'
  },
  prod: {
    hostUrl: 'https://wxapi.zysuan.com',
    host: 'http://localhost:1220'
  }
};
const Env = 'dev';

// const API_IP = 'http://192.168.9.150:9528'; //新的测试环境
const API_IP = '/app'; //新的测试环境
// const API_IP = "http://192.168.9.150:9528/app"; //新的测试环境
// const API_IP = 'http://192.168.199.180:4444/app'; //新的测试环境
// const API_IP = 'http://192.168.9.150:9528/app'; //新的测试环境
// const API_IP = "http://192.168.199.180:9528/app"; //新的测试环境
// const API_IP = 'https://crew-app.airchinacargo.com'; //正式环境

module.exports = {
  Config,
  Env,
  API_IP
};
